// SMD-899: reveal/mask control for password inputs.
//
// Only the input's `type` changes, so name, id and autocomplete stay untouched and
// password managers keep recognising the field. Nothing is stored: the server always
// renders the input as `type=password`, so a reload or navigating away masks it again.
//
// Delegated from the document, so it also covers fields rendered after page load.
// Named after the auth bundle, which loads on every auth page, so the hook cannot
// collide with an unrelated password control added later.
const TOGGLE_SELECTOR = '.js-auth-password-visibility-toggle';

const LABEL_SHOW = 'Show password';
const LABEL_HIDE = 'Hide password';

function inputFor(toggle) {
  const field = toggle.closest('.password-field');

  return field && field.querySelector('input');
}

function apply(toggle, input, visible) {
  input.type = visible ? 'text' : 'password';

  // The label announces the action the control performs, not the current state,
  // which is what a screen reader user needs when focusing it.
  toggle.setAttribute('aria-label', visible ? LABEL_HIDE : LABEL_SHOW);

  // Which icon shows is driven off aria-pressed in CSS, so this stays the only
  // place that knows about state and the markup needs no icon bookkeeping.
  toggle.setAttribute('aria-pressed', String(visible));
}

document.addEventListener('click', (e) => {
  const toggle = e.target.closest(TOGGLE_SELECTOR);
  if (!toggle) { return; }

  e.preventDefault();

  const input = inputFor(toggle);
  if (!input) { return; }

  const willBeVisible = input.type === 'password';
  apply(toggle, input, willBeVisible);

  // Focus returns to the field with the caret at the end, so a reveal does not
  // interrupt typing.
  const caret = input.value.length;
  input.focus();
  input.setSelectionRange(caret, caret);
});
